import React from 'react'
import { SvgIcon } from '@mui/material'

export const CameraIcon = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M15.83 5.42h-1.06l-.27-.84a2.5 2.5 0 0 0-2.37-1.66H7.87a2.5 2.5 0 0 0-2.37 1.7l-.27.84H4.17a2.5 2.5 0 0 0-2.5 2.5v6.66a2.5 2.5 0 0 0 2.5 2.5h11.66a2.5 2.5 0 0 0 2.5-2.5V7.96a2.5 2.5 0 0 0-2.5-2.54Zm.84 9.16a.83.83 0 0 1-.84.84H4.17a.83.83 0 0 1-.84-.84V7.92a.83.83 0 0 1 .84-.84h1.66a.83.83 0 0 0 .84-.56l.45-1.37a.83.83 0 0 1 .79-.57h4.27a.83.83 0 0 1 .79.57l.45 1.37a.83.83 0 0 0 .75.56h1.66a.83.83 0 0 1 .84.84v6.66ZM10 7.08a3.33 3.33 0 1 0 0 6.67 3.33 3.33 0 0 0 0-6.67Zm0 5a1.67 1.67 0 1 1 0-3.33 1.67 1.67 0 0 1 0 3.33Z"
      fill="#fff"
    />
  </SvgIcon>
)
